import { render, staticRenderFns } from "./set-label.vue?vue&type=template&id=13c77eb2&scoped=true&"
import script from "./set-label.vue?vue&type=script&lang=js&"
export * from "./set-label.vue?vue&type=script&lang=js&"
import style0 from "./set-label.vue?vue&type=style&index=0&id=13c77eb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c77eb2",
  null
  
)

export default component.exports